import React from "react";
import { Routes, Route } from "react-router-dom";
import ListMeetings from "../Components/Meetings/listMeetings";
import ViewListMeeting from "../Components/Meetings/viewListMeeting";

const MeetingRoutes = () => {
  return (
    <Routes>
      <Route path="/meeting" element={<ListMeetings></ListMeetings>}></Route>
      <Route path="/meeting/view-meeting/:id" element={<ViewListMeeting></ViewListMeeting>}></Route>
    </Routes>
  );
};

export default MeetingRoutes;
